import React, { useState } from 'react'
import styled from 'styled-components'
import { Button, Link } from './index'
import { Media, Devices } from '../theme'
const Wrapper = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  width: 600px;
  border-radius: 4px;
  padding: 14px 64px;
  background: #ffffff;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: ${p => (p.isHidden ? 'none' : 'flex')};
  align-items: center;
  justify-content: space-between;
  p {
    color: #3d3d3d;
    a {
      color: ${p => p.theme.color.secondary};
    }
  }
  button {
    border-radius: 4px;
  }
  @media ${Devices.phone} {
    width: 100%;
    height: unset;
    bottom: 0;
    padding: 0.4rem;
    flex-wrap: wrap;
    justify-content: center;
    p {
      font-size: 0.28rem;
      text-align: center;
      a {
        font-size: 0.3rem;
      }
    }
    button {
      margin-top: 0.32rem;
      line-height: 0.64rem;
      height: 0.64rem;
    }
  }
`

const Text = styled.p`
  margin: 0;
  color: #fff;
  max-width: 1400px;
  font-size: 14px;
  line-height: 1.5;
  a {
    color: #fff;
    text-decoration: underline;
    font-size: 14px;
  }
  ${Media.phone`
    width: 100%;
    font-size: .24rem;
    a {
      font-size: .24rem;
    }
  `}
`

const Disclaimer = () => {
  const [isHidden, setIsHidden] = useState(true)

  React.useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      window.onload = () => {
        setTimeout(() => {
          const hidden = localStorage.getItem('disclaimer-hidden')
          if (!Boolean(hidden)) {
            setIsHidden(false)
          }
        }, 500)
      }
    }
  }, [setIsHidden])

  const handleClick = agree => {
    localStorage.setItem('consent-mode', agree)
    setIsHidden(true)
    localStorage.setItem('disclaimer-hidden', true)
  }

  return (
    <Wrapper isHidden={isHidden}>
      <Text>
        By continuing to use this site, you agree to the use of <Link to='/privacy-policy/'> cookies</Link>.
      </Text>
      <Button
        onClick={() => {
          handleClick(true)
        }}
      >
        OK
      </Button>
    </Wrapper>
  )
}

export default Disclaimer
